import { v4 as uuidv4 } from 'uuid';
//
import getKountSDK from './getKountSDK';
import supportedCreditCardTypes from '../../../constants/supportedCreditCardTypes';

export function shouldKount(params) {
  const {
    grandTotalRaw,
    cardDetailsPayload,
    cardToBeStored,
    savedCardPayment,
  } = params;

  if (grandTotalRaw < 440) {
    if (savedCardPayment && cardDetailsPayload.cardType === supportedCreditCardTypes.NEW_DAY) {
      return true;
    }

    if (cardDetailsPayload?.creditCardDetails?.cardType === supportedCreditCardTypes.NEW_DAY && !cardToBeStored) {
      return true;
    }
  }

  return false;
}

export function isTestEnvironment() {
  if (window.publicJLSiteDomain?.includes('johnlewis')) return false;

  return true;
}

export function getEnvironmentParam() {
  if (isTestEnvironment()) return 'TEST';

  return 'PROD';
}

export function generateKountSessionId() {
  return uuidv4().replace(/-/g, '');
}

export const initKount = params => dispatch => (
  new Promise((resolve) => {
    const {
      callbackFunction,
      callbackParams,
    } = params;

    if (!shouldKount(params)) {
      resolve(dispatch(callbackFunction(callbackParams)));
    } else {
      let timeoutHappened = false;

      const timeout = setTimeout(() => {
        timeoutHappened = true;
        resolve(dispatch(callbackFunction(callbackParams)));
      }, 5000);

      const kountConfig = {
        clientID: '888840',
        environment: getEnvironmentParam(),
        isSinglePageApp: true,
        isDebugEnabled: isTestEnvironment(),
        callbacks: {
          'collect-end': (responseParams) => {
            if (!timeoutHappened) {
              clearTimeout(timeout);

              resolve(dispatch(callbackFunction({
                ...callbackParams,
                body: {
                  ...callbackParams.body,
                  fraudSessionId: responseParams?.SessionID,
                },
              })));
            }
          },
        },
      };

      const kountSDK = getKountSDK();

      const sdk = kountSDK(kountConfig, generateKountSessionId());
      if (!sdk) {
        // SDK failed for some reason so proceed to payment
        clearTimeout(timeout);
        resolve(dispatch(callbackFunction(callbackParams)));
      }
    }
  })
);

export default initKount;
